var React = require('react');

function SoccerShoe32px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M28.949 14h-2.001v1a.998.998 0 1 1-1.995 0v-1h-1.996v1a.998.998 0 1 1-1.996 0v-1h-1.995v1a.998.998 0 1 1-1.996 0v-1H9.985v1a.998.998 0 1 1-1.995 0v-1H5.994v1a.998.998 0 1 1-1.995 0v-1.004c-1.306-.01-2.271-.342-2.939-1.024-1.127-1.148-1.098-2.888-1.064-4.903C.001 7.723.007 7.365.007 7c0-4.252 1.567-7 3.992-7 1.319 0 2.014.607 2.573 1.093C7.13 1.58 7.613 2 8.988 2c1.526 0 2.163-.511 2.837-1.052C12.38.504 13.008 0 13.977 0c1.066 0 1.846.637 2.75 1.374.919.751 2.064 1.685 4.025 2.504 1.004.419 2.173.843 3.41 1.292 4.821 1.749 7.776 2.918 7.776 4.83 0 1.496 0 4-2.989 4zM15.466 2.925C14.743 2.334 14.317 2 13.977 2c-.246 0-.444.14-.905.51C12.288 3.138 11.213 4 8.988 4 6.867 4 5.94 3.193 5.262 2.602 4.803 2.201 4.571 2 3.999 2 2.703 2 2.003 4.576 2.003 7c0 .377-.006.745-.012 1.101-.026 1.566-.049 2.918.491 3.469.281.285.81.43 1.574.43h6.164l5.735-8.684c-.166-.133-.341-.27-.489-.391zm2.12 1.546L12.613 12h1.598l4.532-6.862c-.42-.221-.805-.445-1.157-.667zm2.985 1.483c-.016.033-.019.069-.04.101L16.605 12h1.599l3.662-5.547a71.412 71.412 0 0 1-1.295-.499zm3.204 1.204c-.013.023-.014.05-.03.073L20.597 12h8.352c.782 0 .993 0 .993-2-.324-.699-3.858-2.004-6.167-2.842z","key":1})]);
}

SoccerShoe32px.displayName = "SoccerShoe32px";

SoccerShoe32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 31.94 16"};

module.exports = SoccerShoe32px;

SoccerShoe32px.default = SoccerShoe32px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/soccer-shoe-32px.svg
// module id = 1111
// module chunks = 0